import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import dhanLogo from "../assets/img/dhan_logo.png";  // Import the logo image
import { StyledTypography } from '../components/StyledTypography'; // Import the StyledTypography
import DecorativeLamp from '../components/DecorativeLamp';
import GradientAnimation from '../components/GradientAnimation';


const LoaderContainer = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1300,
  overflow: 'hidden',
  background: 'linear-gradient(180deg, #ffffff 100%, #800000 10%)',  // White to burgundy gradient
}));

const LogoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  paddingTop: '50px',
}));

const Logo = styled('img')(({ theme }) => ({
  marginTop: theme.spacing(5),
  position: 'absolute',
  top: '70%',
  left: '50%',
  transform: 'translate(-50%, -50%) scale(0)',  // Center and scale down initially
  width: '30vw',  // Make logo size responsive using viewport width
  height: 'auto',
  zIndex: 1,  // Ensure the logo is above other elements
  transition: 'transform 0.5s ease-out, opacity 0.5s ease-out',  // Apply the pop-out and fade-in effect
  animation: 'popOut 0.5s forwards, fadeIn 1s forwards',  // Combine animations
  '@keyframes popOut': {
    '0%': {
      transform: 'translate(-50%, -50%) scale(0)',  // Start scaled down
    },
    '100%': {
      transform: 'translate(-50%, -50%) scale(1)',  // Scale to original size
    },
  },
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,  // Start invisible
    },
    '100%': {
      opacity: 1,  // Fade in
    },
  },
  '@media (max-width: 600px)': {  // Responsive size adjustments
    width: '50vw',  // Larger size on smaller screens
  },
}));

const FullPageLoader = () => {
  const [showLogo, setShowLogo] = useState(true);

  useEffect(() => {
    // Set the timer to hide the loader after 5 seconds
    const timer = setTimeout(() => {
      setShowLogo(false);
    }, 5000); // Set duration here (e.g., 5000ms for 5 seconds)

    // Clear the timer if the component unmounts
    return () => clearTimeout(timer);
  }, []);

  return (
    
    <LoaderContainer>
    {/* <StyledTypography variant="h4" sx={{ position: 'absolute', top: '25%', zIndex: 2 }}>
      Welcome to Dhanalakshmi Group
    </StyledTypography> */}
    {/* <StyledTypography variant="h5" sx={{ position: 'absolute', top: '35%', zIndex: 2 }}>
      Annual Meet 2024
    </StyledTypography> */}
  
  <Box
      sx={{
        display: 'flex',                // Use flexbox layout
        alignItems: 'center',           // Center items vertically
        justifyContent: 'center',       // Center items horizontally
        height: '100vh',                // Full viewport height
       paddingLeft:'120px'
        
      }}
    >
      
      <DecorativeLamp />
    </Box>
    {/* <StyledTypography  variant="h2" sx={{ position: 'absolute', top: '25%', zIndex: 2 }}>
              <span>W</span>
              <span>e</span>
              <span>l</span>
              <span>c</span>
              <span>o</span>
              <span>m</span>
              <span>e</span>
              <span> </span>
              <span>t</span>
              <span>o</span>
              <span> </span>
              <span>D</span>
              <span>h</span>
              <span>a</span>
              <span>n</span>
              <span>a</span>
              <span>l</span>
              <span>a</span>
              <span>k</span>
              <span>s</span>
              <span>h</span>
              <span>m</span>
              <span>i</span>
              <span> </span>
              <span>G</span>
              <span>r</span>
              <span>o</span>
              <span>u</span>
              <span>p</span>
            </StyledTypography> */}
    {showLogo && (
      <Logo src={dhanLogo} alt="Dhan Logo" />
    )}
    
  </LoaderContainer>
  );
};

export default FullPageLoader;
